module.exports = __webpack_public_path__ + "img/20200504_155008.e71766e0.jpg";